var Scinet = Scinet || {};

// handles only simplest cases
Scinet.stringFormat = function (source) {

    for (var i = 1; i < arguments.length; i++) {
        source = source.replace("{" + (i - 1) + "}", arguments[i]);
    }

    return source;
};
